import React from "react";
import { formatChemicalFormulas, nbsp } from "../utilities";
const Header = ({ chosenCategory, chosenValue, mockDataCategory, }) => {
    var _a;
    const descriptionFiltered = mockDataCategory.values.find((e) => {
        return e.id === chosenValue.chosenValueId;
    });
    const isBracket = chosenValue.chosenValueLabel.indexOf("[");
    const firstPartHeader = chosenCategory.chosenCategoryLabel;
    const secondPartHeader = isBracket != -1
        ? chosenValue.chosenValueLabel.substring(0, isBracket)
        : chosenValue.chosenValueLabel;
    return (React.createElement("section", { className: "description" },
        React.createElement("h5", { className: "fs-4 fw-bold" }, formatChemicalFormulas(`${firstPartHeader} - ${secondPartHeader}`)),
        React.createElement("p", null, formatChemicalFormulas(nbsp((_a = descriptionFiltered === null || descriptionFiltered === void 0 ? void 0 : descriptionFiltered.description) !== null && _a !== void 0 ? _a : "")))));
};
export default Header;
